module.exports = __webpack_public_path__ + "img/北豆根.1327ce74.jpg";